import axios from 'axios'
import router from '../router'
import { Message } from 'element-ui'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 从环境变量中获取基础URL
  timeout: 500000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从localStorage中获取token
    const token = localStorage.getItem('token')
    // 如果token存在，添加到请求头中
    if (token) {
      config.headers['Authorization'] = `${token}`
    }
    return config
  },
  error => {
    // 处理请求错误
    console.error('request error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    console.log("res response",response)
    // 检查响应状态
    if (res.status !== 200) {
     
      
      // 处理特定错误码
      if (res.status === 101) {
        // 未授权，跳转到登录页
        localStorage.removeItem('token')
        Message({
          message: 'Please login first',
          type: 'error',
          duration: 5 * 1000
        })
        if (router.currentRoute.path !== '/') {
          router.push('/')
        }   
      }else if (res.status === 411) {
        Message({
          message:res.msg,
          type: 'error',
          duration: 5 * 1000
        })
        // 未授权，跳转到登录页
        localStorage.removeItem('token')
        if (router.currentRoute.path !== '/') {
          router.push('/')
        }
      }else if (res.status === 102) {
        Message({
          message: res.msg,
          type: 'error',
          duration: 5 * 1000
        })
        // 未授权，跳转到登录页
        localStorage.removeItem('token')
       if (router.currentRoute.path !== '/') {
          router.push('/')
        }
      }else {
        Message({
          message: res.msg || 'Please login first',
          type: 'error',
          duration: 5 * 1000
        })
      }
    
      return Promise.reject(res.msg || 'fail');
      // return res;
    } else {
      return res
    }
  },
  error => {
    console.error('response error:', error)
    // 处理响应错误
    if (error.response) {
      const status = error.response.status

      console.log('status',status)
      // 处理401错误（未授权）
      if (status === 411 || status === 102 || status === 101) {
        localStorage.removeItem('token')
        if (router.currentRoute.path !== '/') {
          router.push('/')
        } 
        Message({
          message: '登录已过期，请重新登录',
          type: 'error',
          duration: 5 * 1000
        })
      } else {
        // 其他错误
        Message({
          message: error.response.data.msg || '请求失败',
          type: 'error',
          duration: 5 * 1000
        })
      }
    } else {
      // 网络错误
      Message({
        message: '网络错误，请检查网络连接',
        type: 'error',
        duration: 5 * 1000
      })
    }

    return Promise.reject(error)
  }
)

export default service